import { axios } from '@/services/axios';

const getCompanyPlatforms = async (accountScope, companyId) => {
    const res = await axios.get(`/Company/${companyId}/Platforms/Available`, {
        headers: {
            'X-RequestScope': accountScope,
        },
    });
    return res.data;
};

export default getCompanyPlatforms;
